import { createReducer } from '@mews/framework';
import { STEP_CHANGED } from '../actions/types';
import EnterpriseBuilderScreenStep from '../EnterpriseBuilderScreenStep';

export default createReducer(
    { currentStep: EnterpriseBuilderScreenStep.Dashboard },
    {
        [STEP_CHANGED]: (state: { currentStep: EnterpriseBuilderScreenStep }, step: EnterpriseBuilderScreenStep) => ({
            ...state,
            currentStep: step,
        }),
    }
);
